// The conversation, with the in-flight turn streaming at the bottom. Auto-scrolls
// so the newest words stay visible while you're talking.

import { useEffect, useRef } from 'react';

function Bubble({ role, text, partial }) {
  const isUser = role === 'user';
  return (
    <div className={`flex ${isUser ? 'justify-end' : 'justify-start'}`}>
      <div
        className={`max-w-[80%] rounded-2xl px-4 py-2 text-sm leading-relaxed ${
          isUser
            ? 'rounded-br-sm bg-sky-600/20 text-sky-100'
            : 'rounded-bl-sm bg-slate-800 text-slate-200'
        } ${partial ? 'opacity-60' : ''}`}
      >
        <div className="mb-0.5 text-[10px] uppercase tracking-wider opacity-50">
          {isUser ? 'You' : 'Coach'}
        </div>
        {text}
      </div>
    </div>
  );
}

export default function LiveTranscript({ turns, userPartial, coachPartial, empty }) {
  const endRef = useRef(null);
  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
  }, [turns, userPartial, coachPartial]);

  const nothingYet = turns.length === 0 && !userPartial && !coachPartial;

  return (
    // Bounded rather than growing with the conversation: the mic control sits
    // above it, and an unbounded transcript would push the control off-screen
    // exactly when a session is running.
    <div className="thin-scroll max-h-[55vh] min-h-[14rem] space-y-3 overflow-y-auto rounded-xl border border-slate-800 bg-slate-900/40 p-4">
      {nothingYet && (
        <p className="mt-10 text-center text-sm text-slate-500">{empty}</p>
      )}
      {turns.map((t, i) => (
        <Bubble key={i} role={t.role} text={t.text} />
      ))}
      {userPartial && <Bubble role="user" text={userPartial} partial />}
      {coachPartial && <Bubble role="coach" text={coachPartial} partial />}
      <div ref={endRef} />
    </div>
  );
}
